import React, { useEffect, useState } from 'react';
import { User, LogOut } from 'lucide-react';
import VW from '../Assets/VW-logo.png';
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const loggedIn = sessionStorage.getItem("isLoggedIn");
    const storedUser = sessionStorage.getItem("userName");

    if (loggedIn === "true") {
      setIsLoggedIn(true);
      setUserName(storedUser || "Admin");
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();   // clear session
    setIsLoggedIn(false);
    navigate("/login");       // go to login page
  };

  return (
    <header className="shadow-lg sticky top-0 z-50" style={{ backgroundColor: '#f5f5f5' }}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">

          {/* Logo */}
          <Link to="/">
            <img src={VW} alt="Logo" className="w-auto h-20" />
          </Link>

          <div className="flex items-center space-x-4">
            {isLoggedIn ? (
              <div className="flex items-center space-x-3 bg-slate-100 px-4 py-2 rounded-lg">
                <User className="w-5 h-5 text-slate-700" />
                <span className="text-sm font-semibold text-slate-800">
                  {userName}
                </span>

                <button
                  onClick={handleLogout}
                  className="ml-3 text-red-600 hover:text-red-800 flex items-center space-x-1"
                >
                  <LogOut className="w-4 h-4" />
                  <span>Logout</span>
                </button>
              </div>
            ) : (
              <h2 className="text-lg font-semibold text-slate-800">
                Welcome
              </h2>
            )}
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;
